import { useMutation } from '@apollo/client';
import UPDATE_USER_CONTENT_SHARE_SUBSCRIPTION from 'graphql/mutations/userContentShareSubscriptions/UpdateUserContentShareSubscription.graphql';

export default function useUpdateUserContentShareSubscriptionMutation() {
  return useMutation(UPDATE_USER_CONTENT_SHARE_SUBSCRIPTION);
}
